import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

interface ProjectFormProps {
  open: boolean;
  onClose: () => void;
  project?: any;
  onSubmit: (data: any) => void;
}

export const ProjectForm: React.FC<ProjectFormProps> = ({ open, onClose, project, onSubmit }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = React.useState({
    projectId: project?.project_id || '',
    name: project?.name || '',
    description: project?.description || '',
    salesScript: project?.sales_script || ''
  });

  React.useEffect(() => {
    if (project) {
      setFormData({
        projectId: project.project_id || '',
        name: project.name || '',
        description: project.description || '',
        salesScript: project.sales_script || ''
      });
    }
  }, [project]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{project ? t('edit') || 'Edit' : t('create') || 'Create'} {t('project') || 'Project'}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label={t('project_id') || 'Project ID'}
          value={formData.projectId}
          onChange={e => setFormData({ ...formData, projectId: e.target.value })}
          margin="normal"
          required
          type="number"
        />
        <TextField
          fullWidth
          label={t('name') || 'Name'}
          value={formData.name}
          onChange={e => setFormData({ ...formData, name: e.target.value })}
          margin="normal"
          required
        />
        <TextField
          fullWidth
          label={t('description') || 'Description'}
          value={formData.description}
          onChange={e => setFormData({ ...formData, description: e.target.value })}
          margin="normal"
          multiline
          rows={3}
        />
        <TextField
          fullWidth
          label="Скрипт продаж"
          value={formData.salesScript}
          onChange={e => setFormData({ ...formData, salesScript: e.target.value })}
          margin="normal"
          multiline
          rows={10}
          placeholder="Введите скрипт продаж для операторов. Этот скрипт будет использоваться для оценки качества звонков на этапе презентации."
          helperText="Скрипт используется в Контроле качества 2 для оценки соответствия презентации оператора"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel') || 'Cancel'}</Button>
        <Button onClick={() => onSubmit(formData)} variant="contained">{t('submit') || 'Submit'}</Button>
      </DialogActions>
    </Dialog>
  );
}; 